// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgentItemFormController from "./agent_item_form_controller"
application.register("agent-item-form", AgentItemFormController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import BankAccountComboboxController from "./bank_account_combobox_controller"
application.register("bank-account-combobox", BankAccountComboboxController)

import BarChartController from "./bar_chart_controller"
application.register("bar-chart", BarChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ConfirmationCodeController from "./confirmation_code_controller"
application.register("confirmation-code", ConfirmationCodeController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import FilterChipsController from "./filter_chips_controller"
application.register("filter-chips", FilterChipsController)

import FormFillerController from "./form_filler_controller"
application.register("form-filler", FormFillerController)

import GlobalSearchController from "./global_search_controller"
application.register("global-search", GlobalSearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LinksFormController from "./links_form_controller"
application.register("links-form", LinksFormController)

import MapSearchController from "./map_search_controller"
application.register("map-search", MapSearchController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NotificationSettingDaySelectController from "./notification_setting_day_select_controller"
application.register("notification-setting-day-select", NotificationSettingDaySelectController)

import PastebinController from "./pastebin_controller"
application.register("pastebin", PastebinController)

import PatternMatcherController from "./pattern_matcher_controller"
application.register("pattern-matcher", PatternMatcherController)

import PersistedFilterController from "./persisted_filter_controller"
application.register("persisted-filter", PersistedFilterController)

import PharmacySelectorController from "./pharmacy_selector_controller"
application.register("pharmacy-selector", PharmacySelectorController)

import QuickInputController from "./quick_input_controller"
application.register("quick-input", QuickInputController)

import QuickLoginController from "./quick_login_controller"
application.register("quick-login", QuickLoginController)

import ReconcileFilterController from "./reconcile_filter_controller"
application.register("reconcile-filter", ReconcileFilterController)

import ScrollDownController from "./scroll_down_controller"
application.register("scroll-down", ScrollDownController)

import SimpleMarkdownController from "./simple_markdown_controller"
application.register("simple-markdown", SimpleMarkdownController)

import SupportTicketFormController from "./support_ticket_form_controller"
application.register("support-ticket-form", SupportTicketFormController)

import SupportTicketsController from "./support_tickets_controller"
application.register("support-tickets", SupportTicketsController)

import SyncRuleBannerController from "./sync_rule_banner_controller"
application.register("sync-rule-banner", SyncRuleBannerController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TagFilterController from "./tag_filter_controller"
application.register("tag-filter", TagFilterController)

import TagsInputController from "./tags_input_controller"
application.register("tags-input", TagsInputController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TransformationController from "./transformation_controller"
application.register("transformation", TransformationController)
